import { Routes } from '@angular/router';
import { LogoutComponent } from './session/logout/logout.component';

import { AssignmentListComponent } from './assignment/assignment-list/assignment-list.component';
import { AssignmentContextViewComponent } from './assignment/assignment-context-view/assignment-context-view.component';

import { ProjectContextViewComponent } from './project/project-context-view/project-context-view.component';
import { ProjectListComponent } from './project/project-list/project-list.component';

import { DriverScheduleComponent } from './schedule/driver-schedule/driver-schedule.component';
import { VehicleScheduleComponent } from './schedule/vehicle-schedule/vehicle-schedule.component';

import { LoadunitListComponent } from './masterdata/loadunit/loadunit-list/loadunit-list.component';
import { LoadunitContextViewComponent } from './masterdata/loadunit/loadunit-context-view/loadunit-context-view.component';

import { DriverListComponent } from './masterdata/driver-list/driver-list.component';
import { DriverContextViewComponent } from './masterdata/driver-context-view/driver-context-view.component';

import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { RoleGuard } from './shared/services/role-guard';
import { ROLE_ADMIN, ROLE_AZUBI, ROLE_DISPO, ROLE_OM, ROLE_FLEET } from './shared/services/session.service';
import { LoginFailedComponent } from './shared/services/login-failed/login-failed.component';
import { AuthRedirectComponent } from './shared/services/auth-redirect/auth-redirect.component';

export const routes: Routes = [
  {
    path: 'tour',
    component: AssignmentListComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_AZUBI, ROLE_ADMIN, ROLE_DISPO] },
  },
  {
    path: 'schedule/driver',
    component: DriverScheduleComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_AZUBI, ROLE_ADMIN, ROLE_OM, ROLE_FLEET, ROLE_DISPO] },
  },
  {
    path: 'schedule/vehicle',
    component: VehicleScheduleComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_AZUBI, ROLE_ADMIN, ROLE_OM, ROLE_FLEET, ROLE_DISPO] },
  },
  {
    path: 'masterdata/loadunits',
    component: LoadunitListComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_ADMIN, ROLE_OM, ROLE_FLEET] },
  },
  {
    path: 'masterdata/driver',
    component: DriverListComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_ADMIN, ROLE_OM, ROLE_FLEET] },
  },
  {
    path: 'assignment/:assignmentId/:type',
    outlet: 'right',
    component: AssignmentContextViewComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_AZUBI, ROLE_ADMIN, ROLE_DISPO] },
  },
  {
    path: 'project',
    outlet: 'right',
    component: ProjectListComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_AZUBI, ROLE_ADMIN, ROLE_DISPO] },
  },
  {
    path: 'project/:projectId',
    outlet: 'right',
    component: ProjectContextViewComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_AZUBI, ROLE_ADMIN, ROLE_DISPO] },
  },
  {
    path: 'masterdata/loadunits/loadunit/:loadunitId',
    outlet: 'right',
    component: LoadunitContextViewComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_ADMIN, ROLE_OM, ROLE_FLEET] },
  },
  {
    path: 'masterdata/loadunits/loadunit',
    outlet: 'right',
    component: LoadunitContextViewComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_ADMIN, ROLE_OM, ROLE_FLEET] },
  },
  {
    path: 'masterdata/drivers/driver/:driverId',
    outlet: 'right',
    component: DriverContextViewComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_ADMIN, ROLE_OM, ROLE_FLEET] },
  },
  {
    path: 'masterdata/drivers/driver',
    outlet: 'right',
    component: DriverContextViewComponent,
    canActivate: [RoleGuard],
    data: { roles: [ROLE_ADMIN, ROLE_OM, ROLE_FLEET] },
  },

  { path: 'logout', component: LogoutComponent },
  { path: 'redirect', component: AuthRedirectComponent },
  { path: 'login-failed', component: LoginFailedComponent },
  { path: 'access-denied', component: AccessDeniedComponent },

  { path: '', redirectTo: 'schedule/vehicle', pathMatch: 'full' },
  { path: '**', redirectTo: 'schedule/vehicle' },
];
